import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import { useState } from 'react';
function EmployerSignUpCompanyDetails() {
    const [validated, setValidated] = useState(false);

    const handleSubmit = (event) => {
      const form = event.currentTarget;
      if (form.checkValidity() === false) {
        event.preventDefault();
        event.stopPropagation();
      }
  
      setValidated(true);
    };
  
    return (
    <Container fluid className='m-0 p-0' >
       <div style={{ backgroundColor: '#025EA9' }} className='m-0 p-4 header-bg text-center'>
                <Container>
                    <h2 class="text-white pt-3">Sign Up</h2>
                </Container>
            </div>
   
        <Container className='p-4'>
      
        <Row>
        <Col sm={3} className='progressbar-bg'>
        <ul class="StepProgress">
    <li class="StepProgress-item is-done">Company Details</li>
    <li class="StepProgress-item">Industry Focus</li>
    <li class="StepProgress-item ">Contact Person Details</li>
    <li class="StepProgress-item ">Account Security</li>
    <li class="StepProgress-item"> Preview and Submit</li>
      </ul>
        </Col>
        <Col sm={5} style={{margin:'auto'}}>        
    <h6 style={{color:'#025EA9'}}>Employeer</h6>
    <Container className='m-auto'>   
    <Form noValidate validated={validated} onSubmit={handleSubmit}>      
        <Row>
        <Card className='rounded p-4' style={{backgroundColor:'#EBF2F7', border:'1px solid #025EA9'}}> 
        <h6>Company Details</h6>
        <Col sm={12} >
        <Form.Group className="mb-2" controlId="">
        <Form.Label className='label'>Company Name *</Form.Label>
        <Form.Control type="text" className='form-input'placeholder="Enter Company Name" required />
        <Form.Control.Feedback type="invalid">
        Required Field
          </Form.Control.Feedback>
      </Form.Group>
            </Col>
            <Col sm={12} >
        <Form.Group className="mb-2" controlId="">
        <Form.Label className='label'>Employer EIN *</Form.Label>
        <Form.Control type="text" className='form-input'placeholder="Enter Employer EIN" required />
        <Form.Control.Feedback type="invalid">
        Required Field
          </Form.Control.Feedback>
      </Form.Group>
            </Col>
            <Col sm={12} >
        <Form.Group className="mb-2" controlId="">
        <Form.Label className='label'>Business Type *</Form.Label>
        <Form.Select aria-label="Default select example" className='form-input' required >
      <option>Select Business Type </option>
      <option value="Employed">Employed</option>
	<option value="Self-Employed">Self-Employed</option>
	<option value="Unemployed">Unemployed</option>
	<option value="Retired">Retired</option>
	
    </Form.Select>
        
        <Form.Control.Feedback type="invalid">
        Required Field
          </Form.Control.Feedback>
      </Form.Group>
            </Col>
            <Col sm={12} >
        <Form.Group className="mb-2" controlId="">
        <Form.Label className='label'>Industry *</Form.Label>
        <Form.Select aria-label="Default select example" className='form-input' required >
      <option>Select Industry </option>
      <option value="Accounting">Accounting</option>
                                                                                                            <option value="Advertising">Advertising</option>
                                                                                                            <option value="Aerospace">Aerospace</option>
                                                                                                            <option value="Agriculture">Agriculture</option>
                                                                                                            <option value="Aircraft">Aircraft</option>
                                                                                                            <option value="Airline">Airline</option>
                                                                                                            <option value="Animal">Animal</option>
                                                                                                            <option value="Apparel &amp; Accessories">Apparel &amp; Accessories</option>
                                                                                                            <option value="Artificial Intelligence">Artificial Intelligence</option>
                                                                                                            <option value="Arts and Entertainment">Arts and Entertainment</option>
                                                                                                            <option value="Automotive">Automotive</option>
                                                                                                            <option value="Banking">Banking</option>
                                                                                                            <option value="Biotechnology">Biotechnology</option>
                                                                                                            <option value="BPO">BPO</option>
                                                                                                            <option value="Broadcasting">Broadcasting</option>
                                                                                                            <option value="Brokerage">Brokerage</option>
                                                                                                            <option value="Business">Business</option>
                                                                                                            <option value="Call Centers">Call Centers</option>
                                                                                                            <option value="Cargo Handling">Cargo Handling</option>
                                                                                                            <option value="Cement">Cement</option>
                                                                                                            <option value="Chemical">Chemical</option>
                                                                                                            <option value="Construction">Construction</option>
                                                                                                            <option value="Consulting">Consulting</option>
                                                                                                            <option value="Consumer Products">Consumer Products</option>
                                                                                                            <option value="Cosmetics">Cosmetics</option>
                                                                                                            <option value="Customer Care">Customer Care</option>
                                                                                                            <option value="Defense">Defense</option>
                                                                                                            <option value="Education">Education</option>
                                                                                                            <option value="Electrical &amp; Electronics">Electrical &amp; Electronics</option>
                                                                                                            <option value="Energy">Energy</option>
                                                                                                            <option value="Energy and Environment">Energy and Environment</option>
                                                                                                            <option value="Engineering">Engineering</option>
                                                                                                            <option value="Entertainment &amp; Media">Entertainment &amp; Media</option>
                                                                                                            <option value="Finance and Insurance">Finance and Insurance</option>
                                                                                                            <option value="Finance and Insurance">Finance and Insurance</option>
                                                                                                            <option value="Financial Services">Financial Services</option>
                                                                                                            <option value="FMCG">FMCG</option>
                                                                                                            <option value="Food">Food</option>
                                                                                                            <option value="Government">Government</option>
                                                                                                            <option value="Granites Processing">Granites Processing</option>
                                                                                                            <option value="Grocery">Grocery</option>
                                                                                                            <option value="Hardware &amp; Peripherals">Hardware &amp; Peripherals</option>
                                                                                                            <option value="Healthcare">Healthcare</option>
                                                                                                            <option value="Hotels">Hotels</option>
                                                                                                            <option value="Housekeeping">Housekeeping</option>
                                                                                                            <option value="Information Technology">Information Technology</option>
                                                                                                            <option value="Infrastructure">Infrastructure</option>
                                                                                                            <option value="Insurance">Insurance</option>
                                                                                                            <option value="Interior Furniture">Interior Furniture</option>
                                                                                                            <option value="Internet Publishing">Internet Publishing</option>
                                                                                                            <option value="Investment Banking">Investment Banking</option>
                                                                                                            <option value="Legal">Legal</option>
                                                                                                            <option value="Manufacturing">Manufacturing</option>
                                                                                                            <option value="Marketing">Marketing</option>
                                                                                                            <option value="Medical">Medical</option>
                                                                                                            <option value="Milk &amp; Diary Products">Milk &amp; Diary Products</option>
                                                                                                            <option value="Music">Music</option>
                                                                                                            <option value="Newspaper Publishers">Newspaper Publishers</option>
                                                                                                            <option value="Non Profit">Non Profit</option>
                                                                                                            <option value="Personal Care">Personal Care</option>
                                                                                                            <option value="Pharmaceuticals">Pharmaceuticals</option>
                                                                                                            <option value="Publishing">Publishing</option>
                                                                                                            <option value="Real Estate">Real Estate</option>
                                                                                                            <option value="Retail">Retail</option>
                                                                                                            <option value="Retail &amp; Whole sale">Retail &amp; Whole sale</option>
                                                                                                            <option value="Science">Science</option>
                                                                                                            <option value="Semi Conductors">Semi Conductors</option>
                                                                                                            <option value="Service">Service</option>
                                                                                                            <option value="Spiritual">Spiritual</option>
                                                                                                            <option value="Sports">Sports</option>
                                                                                                            <option value="Sports and Recreation">Sports and Recreation</option>
                                                                                                            <option value="Stock &amp; Securities">Stock &amp; Securities</option>
                                                                                                            <option value="Technology">Technology</option>
                                                                                                            <option value="Telecommunications">Telecommunications</option>
                                                                                                            <option value="Tourism">Tourism</option>
                                                                                                            <option value="Transportation">Transportation</option>
                                                                                                            <option value="Transportation and Storage">Transportation and Storage</option>
                                                                                                            <option value="Travel">Travel</option>
                                                     
                                                    <option value="Other">Other</option>
	
    </Form.Select>
        
        <Form.Control.Feedback type="invalid">
        Required Field
          </Form.Control.Feedback>
      </Form.Group>
            </Col>
            <Col sm={12} >
        <Form.Group className="mb-2" controlId="">
        <Form.Label className='label'>Business Address*</Form.Label>
        <Form.Control type="text" className='form-input'placeholder="Enter Business Address " required />
        <Form.Control.Feedback type="invalid">
        Required Field
          </Form.Control.Feedback>
      </Form.Group>
            </Col>
      <Col sm={12} >
      <Form.Group className="mb-2" controlId="">
        <Form.Label className='label'>City * </Form.Label>
        <Form.Control type="text" className='form-input'placeholder="Enter City" required />
        <Form.Control.Feedback type="invalid">
        Required Field
       </Form.Control.Feedback>
      </Form.Group>
         </Col>
         <Col sm={12} >
      <Form.Group className="mb-2" controlId="">
        <Form.Label className='label'>State* </Form.Label>
        <Form.Select aria-label="Default select example" className='form-input' required >
      <option>Select State </option>
     <option value="">Select State</option>
     <option value="Alabama">Alabama</option>
     <option value="Alaska">Alaska</option>
     <option value="Arizona">Arizona</option>
     <option value="Arkansas">Arkansas</option>
     <option value="California">California</option>
     <option value="Colorado">Colorado</option>
     <option value="Connecticut">Connecticut</option>
     <option value="Delaware">Delaware</option>
     <option value="Florida">Florida</option>
     <option value="Georgia">Georgia</option>
     <option value="Hawaii">Hawaii</option>
     <option value="Idaho">Idaho</option>
     <option value="Illinois">Illinois</option>
     <option value="Indiana">Indiana</option>
     <option value="Iowa">Iowa</option>
     <option value="Kansas">Kansas</option>
     <option value="Kentucky">Kentucky</option>
     <option value="Louisiana">Louisiana</option>
     <option value="Maine">Maine</option>
     <option value="Maryland">Maryland</option>
     <option value="Massachusetts">Massachusetts</option>
     <option value="Michigan">Michigan</option>
     <option value="Minnesota">Minnesota</option>
     <option value="Mississippi">Mississippi</option>
     <option value="Missouri">Missouri</option>
     <option value="Montana">Montana</option>
     <option value="Nebraska">Nebraska</option>
     <option value="Nevada">Nevada</option>
     <option value="New Hampshire">New Hampshire</option>
     <option value="New Jersey">New Jersey</option>
     <option value="New Mexico">New Mexico</option>
     <option value="New York">New York</option>
     <option value="North Carolina">North Carolina</option>
     <option value="North Dakota">North Dakota</option>
     <option value="Ohio">Ohio</option>
     <option value="Oklahoma">Oklahoma</option>
     <option value="Oregon">Oregon</option>
     <option value="Pennsylvania">Pennsylvania</option>
     <option value="Rhode Island">Rhode Island</option>
     <option value="South Carolina">South Carolina</option>
     <option value="South Dakota">South Dakota</option>
     <option value="Tennessee">Tennessee</option>
     <option value="Texas">Texas</option>
     <option value="Utah">Utah</option>
     <option value="Vermont">Vermont</option>
     <option value="Virginia">Virginia</option>
     <option value="Washington">Washington</option>
     <option value="West Virginia">West Virginia</option>
     <option value="Wisconsin">Wisconsin</option>
     <option value="Wyoming">Wyoming</option>
	
    </Form.Select>
       
        <Form.Control.Feedback type="invalid">
        Required Field
       </Form.Control.Feedback>
      </Form.Group>
         </Col>
         <Col sm={12} >
      <Form.Group className="mb-2" controlId="">
        <Form.Label className='label'>Zip Code* </Form.Label>
        <Form.Control type="text" className='form-input'placeholder="Enter Zip Code" required />
        <Form.Control.Feedback type="invalid">
        Required Field
       </Form.Control.Feedback>
      </Form.Group>
         </Col>
         </Card>
         </Row>
        <Row>
        <Col className='text-center mt-4'>
        <Card.Link  as={Link} to="/SelectSignupType" className='mr-4 pr-4'><i class="bi bi-arrow-left"></i> Back  </Card.Link> 
        <Button type="submit" className='rounded-button ml-2' > Save and continue <i class="bi bi-arrow-right"></i></Button>
        </Col>
        </Row>
       </Form>
       </Container>
       </Col>
    </Row>
      </Container>

    

     
    </Container>

  );


}

export default EmployerSignUpCompanyDetails